/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TaskInfoDto
 */
export interface TaskInfoDto {
    /**
     *
     * @type {string}
     * @memberof TaskInfoDto
     */
    taskInfoId?: string;
    /**
     *
     * @type {number}
     * @memberof TaskInfoDto
     */
    deviceArchiveId?: number;
    /**
     *
     * @type {string}
     * @memberof TaskInfoDto
     */
    deviceIdentity?: string;
    /**
     *
     * @type {string}
     * @memberof TaskInfoDto
     */
    deviceType?: TaskInfoDtoDeviceTypeEnum;
    /**
     *
     * @type {Date}
     * @memberof TaskInfoDto
     */
    scheduledTime?: Date;
    /**
     *
     * @type {Date}
     * @memberof TaskInfoDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof TaskInfoDto
     */
    updatedAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof TaskInfoDto
     */
    expiresAt?: Date;
    /**
     *
     * @type {string}
     * @memberof TaskInfoDto
     */
    taskType?: TaskInfoDtoTaskTypeEnum;
    /**
     *
     * @type {string}
     * @memberof TaskInfoDto
     */
    stage?: TaskInfoDtoStageEnum;
    /**
     *
     * @type {string}
     * @memberof TaskInfoDto
     */
    result?: string;
    /**
     *
     * @type {string}
     * @memberof TaskInfoDto
     */
    userId?: string;
    /**
     *
     * @type {number}
     * @memberof TaskInfoDto
     */
    userAccountId?: number;
    /**
     *
     * @type {object}
     * @memberof TaskInfoDto
     */
    requestParameters?: object;
    /**
     *
     * @type {object}
     * @memberof TaskInfoDto
     */
    resultExtras?: object;
}

/**
 * @export
 */
export const TaskInfoDtoDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type TaskInfoDtoDeviceTypeEnum =
    (typeof TaskInfoDtoDeviceTypeEnum)[keyof typeof TaskInfoDtoDeviceTypeEnum];

/**
 * @export
 */
export const TaskInfoDtoTaskTypeEnum = {
    HardReset: "HardReset",
    SoftReset: "SoftReset",
    UpdateFirmware: "UpdateFirmware",
    UpdatePayMateFirmware: "UpdatePayMateFirmware",
    StartCharge: "StartCharge",
    StopCharge: "StopCharge",
    UnlockConnector: "UnlockConnector",
    TriggerMessage: "TriggerMessage",
    ClearChargingProfile: "ClearChargingProfile",
    DisableEnableCharging: "DisableEnableCharging",
    ChangeConfiguration: "ChangeConfiguration",
    ChangeExtendedConfiguration: "ChangeExtendedConfiguration",
    SendMessage: "SendMessage",
    DeviceAlert: "DeviceAlert",
    LimitChargeTransaction: "LimitChargeTransaction",
    SetDefaultChargingProfile: "SetDefaultChargingProfile",
    Activate: "Activate",
    SolarOverride: "SolarOverride",
    SetCentralSystemPassThrough: "SetCentralSystemPassThrough",
    PauseResumeChargeTransaction: "PauseResumeChargeTransaction",
    UpdatePayMateConnectorPricing: "UpdatePayMateConnectorPricing",
    SaveDeviceLogFiles: "SaveDeviceLogFiles",
    PowerOutageSchedule: "PowerOutageSchedule",
    GridPowerRestoredNotification: "GridPowerRestoredNotification",
    KickConnection: "KickConnection",
    GetConfiguration: "GetConfiguration",
    SetCoreConfiguration: "SetCoreConfiguration",
    GetDistributionBoardRemoteProfiles: "GetDistributionBoardRemoteProfiles",
    SetDistributionBoardRemoteProfile: "SetDistributionBoardRemoteProfile",
    ClearDistributionBoardRemoteProfile: "ClearDistributionBoardRemoteProfile",
    WatchBalenaDevice: "WatchBalenaDevice",
    UpdateSupervision: "UpdateSupervision",
    SetDisplayedPrice: "SetDisplayedPrice",
    GetDisplayedPrice: "GetDisplayedPrice",
    StartOcppLogUpload: "StartOcppLogUpload",
} as const;
export type TaskInfoDtoTaskTypeEnum =
    (typeof TaskInfoDtoTaskTypeEnum)[keyof typeof TaskInfoDtoTaskTypeEnum];

/**
 * @export
 */
export const TaskInfoDtoStageEnum = {
    Requested: "Requested",
    Started: "Started",
    Complete: "Complete",
    Failed: "Failed",
    Cancelled: "Cancelled",
} as const;
export type TaskInfoDtoStageEnum =
    (typeof TaskInfoDtoStageEnum)[keyof typeof TaskInfoDtoStageEnum];

/**
 * Check if a given object implements the TaskInfoDto interface.
 */
export function instanceOfTaskInfoDto(value: object): value is TaskInfoDto {
    return true;
}

export function TaskInfoDtoFromJSON(json: any): TaskInfoDto {
    return TaskInfoDtoFromJSONTyped(json, false);
}

export function TaskInfoDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TaskInfoDto {
    if (json == null) {
        return json;
    }
    return {
        taskInfoId: json["taskInfoId"] == null ? undefined : json["taskInfoId"],
        deviceArchiveId:
            json["deviceArchiveId"] == null
                ? undefined
                : json["deviceArchiveId"],
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        scheduledTime:
            json["scheduledTime"] == null
                ? undefined
                : new Date(json["scheduledTime"]),
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        expiresAt:
            json["expiresAt"] == null ? undefined : new Date(json["expiresAt"]),
        taskType: json["taskType"] == null ? undefined : json["taskType"],
        stage: json["stage"] == null ? undefined : json["stage"],
        result: json["result"] == null ? undefined : json["result"],
        userId: json["userId"] == null ? undefined : json["userId"],
        userAccountId:
            json["userAccountId"] == null ? undefined : json["userAccountId"],
        requestParameters:
            json["requestParameters"] == null
                ? undefined
                : json["requestParameters"],
        resultExtras:
            json["resultExtras"] == null ? undefined : json["resultExtras"],
    };
}

export function TaskInfoDtoToJSON(value?: TaskInfoDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        taskInfoId: value["taskInfoId"],
        deviceArchiveId: value["deviceArchiveId"],
        deviceIdentity: value["deviceIdentity"],
        deviceType: value["deviceType"],
        scheduledTime:
            value["scheduledTime"] == null
                ? undefined
                : value["scheduledTime"].toISOString(),
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        expiresAt:
            value["expiresAt"] == null
                ? undefined
                : value["expiresAt"].toISOString(),
        taskType: value["taskType"],
        stage: value["stage"],
        result: value["result"],
        userId: value["userId"],
        userAccountId: value["userAccountId"],
        requestParameters: value["requestParameters"],
        resultExtras: value["resultExtras"],
    };
}
